/*
 * マップで下からでてくるDrawerのUI制御用
 */
import _ from 'lodash'

const getDefaultState = () => {
  return {
    isOpen: false,
    component: '',
    target: {},
    full: false,
    forceOpen: false,
    buttonShow: true
  }
}

const state = getDefaultState()

const getters = {
  getSelectedPlace: (state) => {
    return state.component == 'PlaceDetail' ? state.target : {}
  },
  getShowPlaceFull: (state) => state.full,
  getIsOpen: (state) => state.isOpen,
  getForceOpen: (state) => state.forceOpen,
  getIsFull: (state) => state.full,
  getComponent: (state) => state.component,
  getTarget: (state) => state.target,
  getIsShowButton: (state) => state.buttonShow
}

const actions = {
  updateSelectedPlace ({ commit }, place) {
    commit('setTarget', place)
  },
  openPlace({ dispatch }, { place, full }) {
    if (!_.isEmpty(place) && full) {
      const center = {
        lat: place.location.latitude,
        lng: place.location.longitude,
      }
      dispatch('map/setOffset', true, { root: true })
      dispatch('map/updateCenter', center, { root: true })
    }
    if (!_.isEmpty(place)) {
      dispatch('open', { component: 'PlaceDetail', target: place, full: full })
    } else {
      dispatch('close')
    }
  },
  openPlaceInput({ dispatch }, { place, full }) {
    if (!_.isEmpty(place) ) {
      const center = {
        lat: place.location.latitude,
        lng: place.location.longitude,
      }
      dispatch('map/setOffset', true, { root: true })
      dispatch('map/updateCenter', center, { root: true })
      dispatch('open', { component: 'PlaceDetail', target: place, full: full })
    } else {
      dispatch('close')
    }
  },
  openSpotMarkerList({ dispatch }) {
    dispatch('open', { component: 'spotMarkerList' })
  },
  open({ commit }, { component, target = {}, full }) {
    commit('setIsOpen', true)
    commit('setComponent', component)
    commit('setTarget', target)
    commit('setFull', full)
  },
  close({ commit }) {
    commit('setComponent', '')
    commit('setTarget', {})
    commit('setFull', false)
    commit('setIsOpen', false)
    commit('setForceOpen', false)
  },
  // NOTE: 直接URLを開くパターンだとアニメーションの関係でドロワーがうまく開いた状態にならなかったので、強制的に開いた状態にするためのaction
  forceOpen({ commit, dispatch }) {
    dispatch('open', { component: 'BusstopDetail', target: {}, full: true })
    commit('setForceOpen', true)
  },
  updateTarget({ commit, dispatch }, target) {
    dispatch('map/updateCenter', target.location, { root: true })
    commit('setTarget', target)
  },
  showButton({ commit }){
    commit('setButtonShow', true)
  },
  hideButton({ commit }){
    commit('setButtonShow', false)
  },
}

const mutations = {
  setComponent (state, component) {
    state.component = component
  },
  setTarget (state, target) {
    state.target = target
  },
  setFull (state, full) {
    state.full = full
  },
  setIsOpen (state, isOpen) {
    state.isOpen = isOpen
  },
  setForceOpen (state, forceOpen) {
    state.forceOpen = forceOpen
  },
  setButtonShow(state, buttonShow){
    state.buttonShow = buttonShow
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
